// extracted by mini-css-extract-plugin
module.exports = {"playBox":"playBox___13w25"};